import Commands from './commands';

class SIsMember extends Commands {
    constructor(registry) {
        super("sIsMember", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const checkValue = await emitter(node.params[1], options);
        const container = this.registry.get(key);
        if (!container) {
            throw "Set not defined";
        }
        return container.has(checkValue);
    }
}

export default SIsMember;
